import { req } from "@/axios/aqfe"

export const FcstMultiModelsRepo = {
  model: {
    get: () => req("get", 'fcst_multi_models/')
  },
  ensemble: {
    post: (data) => req("post", 'fcst_multi_models/ensemble/', data)
  }
}